import { Button, UIHeading2, UIText1 } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './EmptyListing.css';
import emptyIconUrl from './assets/empty.png';

export interface IEmptyListingProps {
  className?: string;
  onShow: () => void;
  showReset?: boolean;
  onReset?: () => void;
}

export const EmptyListing = ({ className, onShow, showReset, onReset }: IEmptyListingProps) => {
  React.useEffect(() => {
    onShow();
  }, [onShow]);

  return (
    <div className={cn(styles['root'], className)} data-testid="DesktopEmptyListing">
      <div className={styles['text']}>
        <img className={styles['icon']} src={emptyIconUrl} alt="" />
        <UIHeading2>Нет&nbsp;вариантов по&nbsp;вашему запросу</UIHeading2>
        <UIText1 color="text-secondary-default">
          Сбросьте один или&nbsp;несколько фильтров&nbsp;— что‑нибудь найдём!
        </UIText1>
      </div>
      {showReset && (
        <Button theme="main_secondary" size="M" onClick={onReset} data-testid="DesktopEmptyListing.ResetButton">
          Сбросить все
        </Button>
      )}
    </div>
  );
};
